import { MouseEvent } from 'react';

import { IJackpotsInfo } from '@core/js/components/mainUnreleased/BingoScheduler/types';

import { BingoScheduleItem, LobbyGameItem, SiteScheduleGameItem } from '../types';

/**
 *
 *
 * @param {*} { siteSchedulesGames: array, lobbyGames: array, adminGames: array }
 * @return {*} gamesData: array
*/

interface Props {
    siteSchedulesGames: Array<SiteScheduleGameItem>;
    lobbyGames: Array<LobbyGameItem>;
    adminGames: Record<string, any>;
    jackpots: IJackpotsInfo[];
}

type InitialValue = Array<BingoScheduleItem>

const mapBingoScheduleGames = ({ siteSchedulesGames, lobbyGames, jackpots, adminGames = [] }: Props): Array<BingoScheduleItem> =>
    siteSchedulesGames.reduce((gamesData: InitialValue, scheduleGame: SiteScheduleGameItem) => {
        const gameItem = lobbyGames.find((lobbyGame) => lobbyGame.gameName === scheduleGame.name);

        const jackpotObj = jackpots
            .find(({ clubName, gameType }) =>
                clubName === scheduleGame.name && gameType === scheduleGame.gameType) || {};

        if (gameItem && adminGames?.[scheduleGame.name]) {
            gamesData.push({ ...scheduleGame, ...gameItem, ...adminGames[scheduleGame.name], ...jackpotObj });
        }

        return gamesData;
    }, []);

/**
 *
 *
 * @param {*} element: object
 * @param {*} type: string
 * @return {*} boolean
*/
export const isCorrectType = (element: MouseEvent, type: string): boolean => {
    const target = element.target as HTMLElement;

    return target?.localName === type;
};

/**
 *
 *
 * @param {*} element: object
 * @param {*} className: string
 * @return {*} boolean
*/
export const hasClass = (element: MouseEvent<HTMLUListElement>, className: string): boolean => {
    const target = element.target as HTMLElement;

    return target.classList.contains(className);
};

/**
 *
 *
 * @param {*} drawTime: string
 * @return {*} date
*/
export const getRemainingTime = (drawTime: string): number =>
    new Date(`${drawTime.replace(' ', 'T')}Z`).getTime() - new Date().getTime();

export default mapBingoScheduleGames;

/**
 *
 *
 * @param {*} value: number
 * @param {*} sign: string
 * @param {*} translation: string
 * @return {*} string
 */
interface CurrencyParams {
    value: number;
    sign: string;
    translation: string;
}

export const getCurrencyWithSign = ({ value, sign, translation }: CurrencyParams): string => {
    let price = '';

    switch (true) {
        case value === 0:
            price = translation;
            break;
        case value >= 1:
            price = `${sign} ${value}`;
            break;
        default:
            price = `${value}p`;
    }

    return price;
};

/**
 *
 *
 * @param {*} description: string
 * @param {*} name: string
 * @param {*} code: string
 * @return {*} string
 */
interface BingoLabel {
    description: string;
    name: string;
    code: string;
}

export const getBingoLabel = ({ description, name, code }: BingoLabel): string | null => {
    let bingoLabelText = null;

    if (!description?.includes('bingoLabel') || typeof description !== 'string') {
        return bingoLabelText;
    }

    try {
        bingoLabelText = JSON.parse(description)?.bingoLabel;
    } catch (error) {
        console.error(`The structure of your object for (gameName: ${name}, gameCode: ${code}) is not correct, please check!`);
    }

    return bingoLabelText;
};
